<template>
  <section class="challenge-content">
    <div class="left">
      <div class="first">&lt;<span>{{title}}</span>&gt;</div>
      <div class="second">
        <router-link v-for="challenge in challenges" :to="'/challenge/' + challenge.pid" :class="['question', {totalSolved: challenge.total_solved>0}, {solved: challenge.already_solved}]" :key="challenge.pid">
          <div class="challenge-score">{{challenge.score}}pts</div>
          <div class="question-name">
            <span>{{challenge.title}}</span>
          </div>
          <div class="challenge-info">
            <div class="challenge-tag"><span v-for="t in challenge.tag" :key="t">{{t}} </span></div>
            <div class="totalSolved"><span >{{challenge.total_solved}}</span></div>
          </div>
        </router-link>
      </div>
    </div>
    <div class="right">
      <div class="first" v-if="isRank">
        <h5>{{topTeams_}}</h5>
        <table class="table">
          <thead>
            <tr>
              <th>{{rank_}}</th>
              <th>{{team_}}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(r, index) in rankInfo" :key="index">
              <td>{{index + 1}}</td>
              <td>{{r}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'

import { list } from '@/utils/api.js'
import i18n from '@/i18n'

export default {
  data () {
    return {
      challenges: [],
      isRank: true,
      rankInfo: [],
      title: 'CHALLENGES'
    }
  },
  computed: {
    ...mapState(['profile', 'v_locale']),
    ...mapGetters(['gameOver']),
    ...i18n.map(['challenges_', 'topTeams_', 'rank_', 'team_'])
  },
  methods: {
    ...mapMutations([]),
    ...mapActions([])
  },
  created () {
    if (this.gameOver && !this.profile.name) return this.$router.push('login')

    list()
      .then(data => {
        this.challenges = data.problems
        console.log(this.challenges)
      })
      .catch(err => {
        this.$emit('msg', {
          msg: err.message,
          type: 'error',
          delay: 2000
        })
      })
  }
}
</script>

<style lang="less" scoped>
.challenge-content .left .second .question {
  & .block {
    display: none;
  }
  &:hover .block {
    display: block;
  }
  width: 400px;
  height: 160px;
  border: 1px solid #00c8e3;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  vertical-align: middle;
  &.totalSolved {
    border: none;
  }
  &.solved {
    border: none;
  }
  &>.challenge-score {
    font-size: 14px;
    text-align: right;
    line-height: 14px;
    display: block;
    padding-right: 10px;
    height: 20%;
    font-family: Courier;
  }
  .challenge-info {
    display: flex;
    text-align: left;
    padding-left: 10px;
    .challenge-tag {
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .totalSolved {
      flex: 1;
      text-align: right;
      padding-right: 10px;
    }
  }
  .question-name {
    flex: 1;
    overflow: hidden;
  }
  .question-name>span {
    width: auto;
    line-height: 1.6;
    font-size: 30px;
  }
}
.challenge-content .left .first span{
  font-size: 36px;
  line-height: 115px;
  color: #00c8e3;
  margin-bottom: -18px;
  font-family: "OCRAbyBT";
}

.second {
  display: flex;
  flex-wrap: wrap;
}

.challenge-info {
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/themes/dragon/components/challenge.vue